import {Routes} from '@angular/router';
import {UserRouteAccessService} from '../../shared';
import {CampagneComponent} from './campagne.component';
import {CampagneDetailComponent} from './campagne-detail.component';
import {CampagnePopupComponent} from './campagne-dialog.component';
import {CampagneFormationsPopupComponent} from './campagne-formations-dialog.component';


export const campagneRoute: Routes = [
  {
    path: 'campagne',
    component: CampagneComponent,
    data: {
        authorities: ['ROLE_ADMIN', 'ROLE_SYSTEM'],
        pageTitle: 'cadensApp.campagne.home.title'
    },
    canActivate: [UserRouteAccessService]
  }, {
    path: 'campagne/:id',
    component: CampagneDetailComponent,
    data: {
        authorities: ['ROLE_ADMIN', 'ROLE_SYSTEM'],
        pageTitle: 'cadensApp.campagne.home.title'
    },
    canActivate: [UserRouteAccessService]
  }
];

export const campagnePopupRoute: Routes = [
  {
    path: 'campagne-new',
    component: CampagnePopupComponent,
    data: {
        authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN'],
        pageTitle: 'cadensApp.campagne.home.title'
    },
    outlet: 'popup'
  }, {
    path: 'campagne-formations/:campagnes',
    component: CampagneFormationsPopupComponent,
    data: {
        authorities: ['ROLE_SYSTEM', 'ROLE_ADMIN'],
        pageTitle: 'cadensApp.campagne.formations.add'
    },
    outlet: 'popup'
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/campagne/campagne.route.ts